import { getConfigValue } from "../Providers/ConfigsApi";

export default async function FrontendRedirectPaths() {
  try {
    const paths = await getConfigValue('frontend-worldwide-redirect-paths');
    return paths;
  } catch (error) {
    return ['/', '/ephotobook/preview', '/configurable-product/radiance-and-grace'];
  }
}


// WEBPACK FOOTER //
// ./src/Common/Helpers/FrontendRedirectPaths.js